import React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent, DialogHeader, DialogPortal, DialogTitle, DialogTrigger } from '@codes/ui-kit';

import { PrivacyTermsPage } from '../pages';

export const PrivacyTermsDialog = () => {
    const { t } = useTranslation();

    const scrollDivRef = useRef<HTMLDivElement>(null);

    return (
        <Dialog>
            <DialogTrigger asChild>
                <button className="text-[15px] hover:underline">{t('footer.privacyPolicy')}</button>
            </DialogTrigger>
            <DialogPortal>
                <DialogContent
                    ref={scrollDivRef}
                    className="max-md:max-w-full max-md:w-full max-md:max-h-[100vh] max-w-[800px] max-md:rounded-none p-0"
                >
                    <DialogHeader>
                        <DialogTitle>Privacy & Terms</DialogTitle>
                    </DialogHeader>
                    <PrivacyTermsPage isDialog={true} />
                </DialogContent>
            </DialogPortal>
        </Dialog>
    );
};
